import { Params } from '@angular/router';

export class BaseUrlAndQueryParams {
    constructor(
        private _baseUrl: string,
        private _queryParams: Params,
    ) {}

    get baseUrl() {
        return this._baseUrl;
    }

    get queryParams() {
        return this._queryParams;
    }
}
